/** Fortify FAQ content */

import { WITHDRAWAL_NOTICE_EMAIL } from "lib/fortifyContact";

export const faqCategories = {
  general: {
    title: "General",
    questions: [
      {
        question: "What is Fortify?",
        answer:
          "Fortify is a crowdfunding platform that enables eligible private companies to raise capital from individual investors. Fortify is not a registered dealer; it operates as a funding portal relying on the exemption from dealer registration under National Instrument 45-110 (NI 45-110). Fortify does not provide investment advice or assess the merits of any offering.",
      },
      {
        question: "Is Fortify regulated?",
        answer:
          "Fortify Portal, Inc. is not registered as a dealer under any Canadian securities legislation. Fortify operates as a funding portal relying on the exemption from the dealer registration requirement under National Instrument 45-110 Start-up Crowdfunding Registration and Prospectus Exemptions (NI 45-110), as adopted by the provincial and territorial securities regulatory authorities in Canada, including the Ontario Securities Commission (OSC). Fortify is not authorized to, and does not, provide advice about the suitability or merits of any investment. Offerings on the platform are made under the NI 45-110 prospectus exemption and have not been reviewed or approved by any securities regulator.",
      },
      {
        question: "How are companies vetted?",
        answer:
          "Fortify confirms that each issuer is eligible under NI 45-110 and that its Offering Document contains the required information — this is an eligibility and completeness review only. Fortify does not assess the merits, viability, or prospects of any business, does not verify the accuracy of issuer information, and does not endorse any offering. You should do your own research before investing.",
      },
      {
        question: "How is Fortify different from Kickstarter?",
        answer:
          "While Kickstarter is a rewards-based crowdfunding platform where backers receive products or perks, Fortify is an equity crowdfunding platform where investors receive actual ownership stakes (shares) in the companies they invest in.",
      },
    ],
  },
  investing: {
    title: "Investing",
    questions: [
      {
        question: "How and when could I see a return on my investment?",
        answer:
          "There's no set timeline and no guarantee of any return. A payoff would only come if the company is acquired, goes public, or buys them back or if it pays dividends, which most start-ups don't. Be prepared to hold indefinitely and to lose everything. Check each offering's document for the specific terms of your shares.",
      },
      {
        question: "How do I cancel an investment?",
        answer: `Under NI 45-110, you may withdraw your investment by delivering notice to Fortify Portal, Inc. not later than midnight Eastern Time on the second business day after the day on which you entered into the subscription agreement. If the offering document is amended, your withdrawal right is re-triggered and you have until not later than midnight Eastern Time on the second business day after the amendment notification to withdraw. Send withdrawal and cancellation notices to ${WITHDRAWAL_NOTICE_EMAIL}.`,
      },
    ],
  },
  companies: {
    title: "For Companies",
    questions: [
      {
        question: "How can my company raise funds on Fortify?",
        answer:
          "To raise funds on Fortify, your company must be an eligible corporation with its head office in Canada, complete our application process, meet the eligibility criteria under NI 45-110 and our Listing Standards, and prepare a Form 45-110F1 Offering Document. Our team will guide you through the requirements, though Fortify does not assess the merits of your business or your offering.",
      },
      {
        question: "How much can my company raise?",
        answer:
          "Under NI 45-110, an issuer (together with its affiliates) may raise up to $1,500,000 through start-up crowdfunding distributions in a 12-month period. The actual amount depends on your business stage, financials, and offering goals.",
      },
      {
        question: "How long does a campaign last?",
        answer:
          "A crowdfunding distribution can remain open for up to 90 days from the date your Offering Document is first made available to investors on the platform. If the minimum offering amount is not raised within that 90-day period, funds are returned to investors as required by NI 45-110.",
      },
    ],
  },
  security: {
    title: "Security & Legal",
    questions: [
      {
        question: "Where are investments held?",
        answer:
          "Your subscription funds are held in trust in a designated trust account at a CDIC-member Canadian financial institution, separate from Fortify's own assets, until an offering closes or funds are returned to you.",
      },
      {
        question: "What happens if Fortify shuts down?",
        answer:
          "Your share ownership in any company you've already invested in is held directly by you and is unaffected. For any subscription funds still held in trust, Fortify will promptly notify you and the applicable securities regulator and return those funds to you without deduction, in accordance with NI 45-110 and our trust-account and wind-down disclosure.",
      },
    ],
  },
};

export const faqPreviewItems = [
  faqCategories.general.questions[0],
  faqCategories.general.questions[1],
  faqCategories.investing.questions[0],
  faqCategories.investing.questions[1],
  faqCategories.general.questions[2],
];

export const howItWorksFaqs = [
  faqCategories.general.questions[0],
  faqCategories.investing.questions[0],
  faqCategories.general.questions[2],
  faqCategories.investing.questions[1],
  faqCategories.security.questions[1],
];
